import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { queryClient } from '@/lib/react-query';
import { restoreURL } from '@/lib/axios';
import { filterOutFalsyValues } from '@/lib';

import { SelectOpt } from '@/types';

import { AI_QUERY_KEY, AIModulePayload } from '../types';

/**
 * Convert ai module payload to backend needed structure:
 */
const addAIModule = async ({ payload }: { payload: AIModulePayload }) => {
  const record = filterOutFalsyValues(payload);
  // build ai-module struecture:
  const data = {
    is_default: record['isDefault'],
    ai_module_key: payload.label,
    back_module_key: payload.moduleType,
    description: payload.description,
    status: payload.status,
    companies: payload.companies.map((c) => ({
      company_id: c.value,
      label: c.label,
    })),
  };
  await restoreURL().post(`${API_CTX}/ai-modules`, data);
};

export const useCreateAIModule = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  return useMutation<void, Error, { payload: AIModulePayload }>(
    ({ payload }) => addAIModule({ payload }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(AI_QUERY_KEY);
        toast.success(`New AI module created successfully`);

        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error: Error) => {
        toast.error(`An error occurs: ${error.message}`);
      },
    }
  );
};
